/* ROUTER */
import Vue          from 'vue'
import Router       from 'vue-router'
Vue.use(Router)

// let configVars = require('../assets/json/config_bars.json')

export default new Router({
  mode: 'history',
  // base: process.env.NODE_ENV === 'static' ? configVars.base_path : '/',
  base: '/',
  routes: [
  //INICIO
  {
    path: '/',
    name: 'index',
    component: () => import('@/components/Index')
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/components/Projects')
  },
  {
    path: '/experience',
    name: 'experience',
    component: () => import('@/components/Timeline')
  },
  {
    path: '/404',
    name: 'error_404',
    component: () => import('@/components/404')
  },
  // Must be at end of router path
  {
    path: '/:page',
    name: 'extra_page',
    component: () => import('@/components/ExtraPage')
  }
]
});